import React from "react";

const AlquilerVacacionalDetails = ({ costes }) => {
    if (!costes || !costes.detalles || !costes.reformasPremium) {
        return <div className="p-4 text-gray-500">Cargando costes del escenario de alquiler vacacional...</div>;
    }

    const { detalles, reformasPremium, totalesPorCategoria } = costes;

    return (
        <div className="bg-purple-100 p-4 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-purple-700 mb-4">💼 Escenario: Alquiler Vacacional</h2>

            {/* Reformas */}
            <div className="grid md:grid-cols-3 gap-4 mb-6">
                {reformasPremium.map((reforma) => (
                    <div key={reforma.id} className="bg-white p-4 rounded shadow border border-purple-200">
                        <h3 className="text-lg font-semibold text-purple-800 mb-2">Reforma #{reforma.id}</h3>
                        <p>🔧 Coste reforma premium: {reforma.coste_estimado} €</p>
                        {reforma.coste_otros &&
                            Object.entries(reforma.coste_otros).map(([categoria, total]) => (
                                <p key={categoria}>📦 {categoria}: {total} €</p>
                            ))}
                        <p className="mt-2 font-bold text-purple-900">💰 Coste total: {reforma.coste_total} €</p>
                    </div>
                ))}
            </div>

            {/* Detalles por categoría */}
            <div>
                {Object.entries(detalles).map(([categoria, items]) => (
                    <div key={categoria} className="mb-4">
                        <details className="bg-white p-4 rounded shadow cursor-pointer">
                            <summary className="font-semibold text-gray-800 mb-2">
                                {categoria.charAt(0).toUpperCase() + categoria.slice(1)} — Total: {totalesPorCategoria?.[categoria] || 0} €
                            </summary>
                            <ul className="mt-2">
                                {items.map((item, index) => (
                                    <li key={index} className="flex justify-between text-sm border-b py-1">
                                        <span>{item.nombre}</span>
                                        <span>
                                            {parseFloat(item.cantidad).toLocaleString()} ×
                                            {parseFloat(item.coste_unitario).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} € =
                                            {parseFloat(item.total).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </details>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AlquilerVacacionalDetails;